export const services = [
  {
    id: "soluciones-tecnologicas",
    title: "Soluciones Tecnológicas",
    description:
      "Desarrollo de soluciones tecnológicas personalizadas para optimizar procesos empresariales y aumentar la productividad.",
    icon: "fas fa-laptop-code",
    details:
      "Ofrecemos desarrollo de software a medida, automatización de procesos, integración de sistemas y consultoría tecnológica estratégica para impulsar la transformación digital de tu empresa.",
  },
  {
    id: "consultoria",
    title: "Consultoría IT",
    description:
      "Asesoramiento experto en estrategia tecnológica, arquitectura de sistemas y mejores prácticas de la industria.",
    icon: "fas fa-handshake",
    details:
      "Nuestro equipo de consultores expertos analiza tus necesidades empresariales y diseña estrategias tecnológicas alineadas con tus objetivos de negocio, optimizando recursos y maximizando el ROI.",
  },
  {
    id: "formacion",
    title: "Formación Empresarial",
    description:
      "Capacitación profesional en tecnologías emergentes y herramientas digitales para equipos de trabajo.",
    icon: "fas fa-graduation-cap",
    details:
      "Programas de formación personalizados que incluyen talleres presenciales y online, certificaciones profesionales y entrenamiento continuo en las últimas tecnologías del mercado.",
  },
  {
    id: "redes",
    title: "Infraestructura de Redes",
    description:
      "Diseño, implementación y mantenimiento de infraestructuras de red robustas y escalables.",
    icon: "fas fa-network-wired",
    details:
      "Planificación e implementación de redes empresariales, configuración de servidores, optimización de rendimiento y soporte técnico continuo para garantizar conectividad confiable.",
  },
  {
    id: "seguridad",
    title: "Seguridad Informática",
    description:
      "Protección integral de datos y sistemas mediante soluciones avanzadas de ciberseguridad.",
    icon: "fas fa-shield-alt",
    details:
      "Auditorías de seguridad, implementación de firewalls, sistemas de detección de intrusos, cifrado de datos, políticas de seguridad y respuesta a incidentes para proteger tu información crítica.",
  },
];